(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-kinetic"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function initHeroMark(hero) {
    var mark = hero.querySelector('.hero-kinetic__mark');
    if (!mark) return;

    var targetTiltX = 0;
    var targetTiltY = 0;
    var tiltX = 0;
    var tiltY = 0;
    var scrollShift = 0;

    function updateScrollShift() {
      var rect = hero.getBoundingClientRect();
      // Mark drifts a little slower than the page as it scrolls, for depth.
      scrollShift = rect.top * -0.06;
    }

    hero.addEventListener(
      'pointermove',
      function (event) {
        var rect = hero.getBoundingClientRect();
        var px = (event.clientX - rect.left) / rect.width - 0.5;
        var py = (event.clientY - rect.top) / rect.height - 0.5;
        targetTiltX = px * 7;
        targetTiltY = py * -7;
      },
      { passive: true }
    );

    hero.addEventListener('pointerleave', function () {
      targetTiltX = 0;
      targetTiltY = 0;
    });

    window.addEventListener('scroll', updateScrollShift, { passive: true });
    updateScrollShift();

    function render() {
      tiltX += (targetTiltX - tiltX) * 0.06;
      tiltY += (targetTiltY - tiltY) * 0.06;
      mark.style.transform =
        'translateY(calc(-50% + ' + scrollShift.toFixed(1) + 'px))' +
        ' perspective(1400px) rotateX(' + tiltY.toFixed(2) + 'deg) rotateY(' + tiltX.toFixed(2) + 'deg)';
      requestAnimationFrame(render);
    }

    requestAnimationFrame(render);
  }

  document.querySelectorAll('.hero-kinetic').forEach(initHeroMark);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upload-files"]) return;
  try {
    
(function () {
  var UPLOAD_ENDPOINT = 'https://threaderpros-uploads.vercel.app/api/upload';

  function initUploadForm() {
    var form = document.getElementById('upload-files-form');
    if (!form) return;

    var orderInput = document.getElementById('upload-order-number');
    var rosterInput = document.getElementById('upload-roster-file');
    var logoInput = document.getElementById('upload-logo-file');
    var statusEl = form.querySelector('.upload-files__status');
    var submitBtn = form.querySelector('.upload-files__submit');
    var submitLabel = form.querySelector('.upload-files__submit-label');

    // Pre-fill order number from ?order=1023 in the URL, e.g. linked from the
    // order confirmation email.
    var params = new URLSearchParams(window.location.search);
    var prefill = params.get('order');
    if (prefill) {
      orderInput.value = prefill.replace(/^#/, '');
    }

    function setStatus(message, state) {
      statusEl.textContent = message;
      if (state) {
        statusEl.setAttribute('data-state', state);
      } else {
        statusEl.removeAttribute('data-state');
      }
    }

    function uploadOne(orderNumber, type, file) {
      var data = new FormData();
      data.append('order', orderNumber);
      data.append('type', type);
      data.append('file', file);
      return fetch(UPLOAD_ENDPOINT, { method: 'POST', body: data }).then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok) {
            throw new Error(json.error || 'Upload failed.');
          }
          return json;
        });
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var orderNumber = orderInput.value.trim();
      var rosterFile = rosterInput.files[0];
      var logoFile = logoInput.files[0];

      if (!orderNumber) {
        setStatus('Please enter your order number.', 'error');
        orderInput.focus();
        return;
      }
      if (!rosterFile && !logoFile) {
        setStatus('Please choose at least one file to upload.', 'error');
        return;
      }

      submitBtn.disabled = true;
      submitLabel.textContent = 'Uploading…';
      setStatus('Uploading your files, please wait…');

      var tasks = [];
      if (rosterFile) tasks.push(uploadOne(orderNumber, 'roster', rosterFile));
      if (logoFile) tasks.push(uploadOne(orderNumber, 'logo', logoFile));

      Promise.all(tasks)
        .then(function (results) {
          var orderName = results[0] && results[0].order;
          setStatus(
            'Got it! Your files are attached to order ' + (orderName || orderNumber) + '. Thank you!',
            'success'
          );
          form.reset();
          submitLabel.textContent = 'Upload files';
          submitBtn.disabled = false;
        })
        .catch(function (err) {
          setStatus(err.message || 'Something went wrong. Please try again.', 'error');
          submitLabel.textContent = 'Upload files';
          submitBtn.disabled = false;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUploadForm);
  } else {
    initUploadForm();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
